import { Children, cloneElement } from "react";
import { getLoopingDotIndex, getSliderDotCount } from "@/utils/sliderDots";

export default function appendLoopingSlickDots(dotsClass = "slick-dots") {
  return function LoopingSlickDots(dots = []) {
    const list = Children.toArray(dots);
    const count = getSliderDotCount(list.length);
    if (count <= 1) return <ul className={dotsClass} />;

    const activeSlide = list.findIndex((dot) =>
      String(dot?.props?.className || "").includes("slick-active")
    );
    const activeDot = getLoopingDotIndex(Math.max(activeSlide, 0), count);

    return (
      <ul className={dotsClass}>
        {list.slice(0, count).map((dot, index) =>
          cloneElement(dot, {
            className: index === activeDot ? "slick-active" : "",
          })
        )}
      </ul>
    );
  };
}
